import { Component, OnInit, OnDestroy } from '@angular/core'
import { DataService } from '../services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LOGIN } from '../utils/utils';
import { AppConfig } from '../boot/app.config';

@Component({
    selector: 'logoutsso',
    template: require('./logoutsso.component.html'),
    styles: [require('./logoutsso.component.css')]
})
export class LogoutSSOComponent implements OnInit, OnDestroy {
    logoutMsg:string = "";

    constructor(
        private config: AppConfig,
    	private dataservice: DataService,
    	private route: ActivatedRoute,
        private router: Router) { }

    ngOnInit() {
    	//this.dataservice.logout(null, null);
    	//this.router.navigateByUrl(LOGIN);
        console.log("LOGOUT BY SSO TRIGGERED.");
        this.logoutMsg = this.config.getConfig('logoutSSOMsg') || 'Logout SSO Successfully!';
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/logout/logoutsso.component.ts